import { Navigate, useLocation } from 'react-router';

/** Invitation e-mails sent before the link fix point at /invitations/accept; the token stays in the fragment. */
export function LegacyInviteRedirect() {
  const location = useLocation();
  return <Navigate to={{ pathname: '/invite', hash: location.hash }} replace />;
}
